import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { BehaviorSubject } from 'rxjs';
import ProjectDetail from '../../../interfaces/project-detail';
import { REFETCH_PROJECT_DETAILS_AND_DATES } from './graphql/dealDates';
import Project from '../../../interfaces/project';

@Injectable({
  providedIn: 'root',
})
export class DealDatesService {
  private _dates: any = [];
  private dates = new BehaviorSubject(this._dates);
  public dates$ = this.dates.asObservable();

  private _projectDetail: ProjectDetail | null = null;
  private projectDetail = new BehaviorSubject(this._projectDetail);
  public projectDetail$ = this.projectDetail.asObservable();

  constructor(public apollo: Apollo) {}

  public setDates(dates: any) {
    this._dates = dates;
    this.dates.next(this._dates);
  }
  public setDetails(detail: ProjectDetail) {
    this._projectDetail = detail;
    this.projectDetail.next(this._projectDetail);
  }

  public refreshDates(projectId: string) {
    let sub = this.apollo
      .query({
        query: REFETCH_PROJECT_DETAILS_AND_DATES,
        variables: { project_id: projectId },
        fetchPolicy: 'network-only',
      })
      .subscribe(({ data }) => {
        let { project } = data as { project: Project };
        this.setDates(project.projectDates);
        this.setDetails(project.projectDetail as unknown as ProjectDetail);
        sub?.unsubscribe();
      });
  }
}
